(ns common.schema.entity-type-spec
  (:require
   [common.schema.field-spec :as field-spec]
   [common.schema.i18n :as in]))

(def entity-type-definition-model
  [:map
   [:entity-type keyword?]
   [:schema [:vector [:tuple keyword? field-spec/CommonFieldSpec]]]
   [:name in/Translations-en-open]
   [:plural {:optional true} in/Translations-en-open]

   [:icon {:optional true} keyword?]

   [:read-permissions-check-fn fn?]
   [:disable-permissions-check-fn fn?]

   ;; MCP exposure controls. These are consumed by the backend MCP connector
   ;; before normal application read permissions are applied.
   [:mcp {:optional true} map?]
   [:entity/mcp-blacklisted? {:optional true} boolean?]
   [:entity/mcp-read-permissions-check-fn {:optional true} fn?]

   ;; Display name function or keyword path
   [:display-name-fn {:optional true} fn?]
   [:display-name/depends-on {:optional true} [:vector keyword?]]

   ;; For search / indexing
   [:search {:optional true} map?]

   ;; Other extensions
   [:reporting {:optional true} map?]
   [:permissions {:optional true} map?]])
